<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig" :table-items="tableItems" @new-item="newItem" @load-items="getTableData" @row-click="goToDetail" @delete-items="deleteItems" ref="gofixTable">
                            <template slot="gofix_table:contract_name" slot-scope="row">
                                {{ row.item.contract_name ? row.item.contract_name : "N/A" }}
                            </template>
                            <template slot="gofix_table:s_contract_name" slot-scope="row">
                                {{ row.item.s_contract_name ? row.item.s_contract_name : "N/A" }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                    <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create Vendor Linking" hide-footer :centered="true" ref="modal-Create">
                        <b-form class="pb-20">
                            <gofix-form-dropdown 
                                label="Supplier" 
                                vLabel="name" 
                                :filterable="false" 
                                :required="true" 
                                :clearable="false" 
                                @search="searchSupplier" 
                                @change="selectSupplier" 
                                v-model="vendor_linking_supplier" 
                                :options="suppliers" />
                            <gofix-form-dropdown 
                                label="Client Contract" 
                                vLabel="contract_name" 
                                :filterable="false" 
                                :required="true" 
                                @search="searchClientContract" 
                                @change="selectCContract" 
                                v-model="vendor_linking.client_contract" 
                                :options="client_contract" />
                            <gofix-form-tree 
                                label="Service Categories" 
                                :required="true" 
                                valueFormat="object" 
                                :options="service_category" 
                                v-model="vendor_linking.service_category" 
                                :normalizer="normalizer" 
                                :loadOptions="loadOptionsService" 
                                @change="selectService" />
                            <gofix-form-properties 
                                label="Property" 
                                :contract-id="vendor_linking.client_contract ? vendor_linking.client_contract.id : null" 
                                v-model="vendor_linking.property" 
                                @change="selectProperty" 
                                valueFormat="object" 
                                required />
                            <gofix-form-dropdown 
                                label="Supplier Contract" 
                                vLabel="contract_name" 
                                :reduce="option => option['id']" 
                                v-model="vendor_linking.supplier_contract_id" 
                                :options="supplier_contract" />
                            <gofix-form-dropdown 
                                vLabel="reference_value_text" 
                                label="Status" 
                                :reduce="option => option.reference_value_text" 
                                :filterable="false"
                                required
                                v-model="vendor_linking.status" 
                                :options="vendor_linking_status" />
                        </b-form>
                        <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.vendor_linking, 'create')">
                            <gofix-button label="APPLY" @click="saveVendorLinking" :loading="isAction" noBorder></gofix-button>
                        </b-button-group>
                    </b-modal>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { filters } from '@/_filterVar.js'
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500)
}

export default {
    name: 'vendor-linking',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['vendor_linking']));
        return {
            tableConfig: {
                name: 'master-table-vendor-linking',
                controls: {
                    create: this.$checkRole(this.$accessModule.vendor_linking, 'create'),
                    delete: this.$checkRole(this.$accessModule.vendor_linking, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: false,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            isAction: false,
            vendor_linking: {
                client_contract: null,
                supplier_id: null,
                supplier_name: null,
                service_category: null,
                service_category_id: null,
                service_category_name: null,
                property: null,
                property_id: null,
                location_root_path: null,
                location_building_path: null,
                supplier_contract_id: null,
            },
            vendor_linking_supplier: null,
            suppliers: [],
            client_contract: [],
            service_category: [],
            property: [],
            supplier_contract: [],
            loading: {
                serviceCategory: false,
                properties: false,
                supplierContract: false,
            },
            vendor_linking_status: []
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
        })
    },
    async created() {
        this.getVendorLinkingStatus();
    },
    methods: {
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.text,
                    children: node.children
                }
            return {
                id: node.data.id,
                label: node.text,
                children: undefined
            }
        },
        /*-- Table callback --------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if (this.ClientContractID && this.ClientContractID.id) {
                tableRequest.filter.client_contract_id.value = this.ClientContractID.id;
            }
            await this.$store.dispatch("VendorLinkingController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the vendor linking", "danger");
                    reject();
                })
        },
        newItem() {
            this.vendor_linking = {
                client_contract: null,
                supplier_id: null,
                supplier_name: null,
                service_category: null,
                service_category_id: null,
                service_category_name: null,
                property: null,
                property_id: null,
                location_root_path: null,
                location_building_path: null,
                supplier_contract_id: null,
            };
            this.vendor_linking_supplier = null;
            this.getCContract();
            this.getSupplier();
            this.loading.serviceCategory = false
            this.loading.properties = false
            this.loading.supplierContract = false
            this.vendor_linking.client_contract = (this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) ? this.ClientContractID : null
            this.selectCContract(this.vendor_linking.client_contract);
            this.$refs['modal-Create'].show()
        },
        goToDetail(item) {
            this.$router.push(`${this.$route.path}/${item.id}`);
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store.dispatch('VendorLinkingController/deteleItem', ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'vendor_linking'));
                })
                .catch(err => {
                    reject();
                })
        },
        saveVendorLinking() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if (!this.vendor_linking.supplier_id) {
                    return this.$alertNotification("Supplier is a required field.", "danger");
                }

                if (!this.vendor_linking.client_contract_id) {
                    return this.$alertNotification("Client Contarct is a required field.", "danger");
                }

                if (!this.vendor_linking.service_category_id) {
                    return this.$alertNotification("Service Categories is a required field.", "danger");
                }

                if (!this.vendor_linking.property_id) {
                    return this.$alertNotification("Property is a required field.", "danger");
                }

                if (!this.vendor_linking.status) {
                    return this.$alertNotification("Status is a required field.", "danger");
                }

                if (this.isAction) return;
                this.isAction = true;

                let request = {
                    id: this.vendor_linking.id,
                    supplier_id: this.vendor_linking.supplier_id,
                    client_contract_id: this.vendor_linking.client_contract_id,
                    supplier_contract_id: this.vendor_linking.supplier_contract_id,
                    service_category_id: this.vendor_linking.service_category_id,
                    property_id: this.vendor_linking.property_id,
                    location_root_path: this.vendor_linking.location_root_path,
                    location_building_path: this.vendor_linking.location_building_path,
                    status: this.vendor_linking.status,
                    supplier_name: this.vendor_linking.supplier_name,
                    service_category_name: this.vendor_linking.service_category_name
                }
                this.$store.dispatch('VendorLinkingController/createItem', request)
                    .then(response => {
                        this.isAction = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$refs['modal-Create'].hide();
                        this.$alertNotification(this.$notificationV2('adding', 'vendor_linking'));
                    })
                    .catch(error => {
                        this.isAction = false;
                    })
            }, 300);
        },
        /* --- Property ---*/
        selectProperty(value) {
            this.vendor_linking.property_id            = value ? value.id : null;
            this.vendor_linking.location_root_path     = value ? value.root_path : null;
            this.vendor_linking.location_building_path = value ? value.building_path : null;
        },
        /* --- Service Category ---*/
        selectService(value) {
            this.vendor_linking.service_category_id   = value ? value.id : null;
            this.vendor_linking.service_category_name = value ? value.name : null;
        },
        loadOptionsService({
            action,
            parentNode,
            callback
        }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return
                };
                if (parentNode.data.isBatch) {
                    global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/${parentNode.data.id}`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data
                                callback();
                            })
                        })
                } else {
                    parentNode.children = []
                    callback();
                }
            }
        },
        /* --- Supplier ---*/
        selectSupplier(value) {
            this.vendor_linking.supplier_id   = value ? value.id : null;
            this.vendor_linking.supplier_name = value ? value.name : null;
        },
        searchSupplier(search, loading) {
            this.suppliers = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplier({ name: search }, 100);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async getSupplier(filter = {}, limit = 100) {
            filter['is_supplier'] = true
            await this.$store.dispatch('OrganizationController/searchItemsInUser', { filter: filter, limit: limit })
                .then(response => {
                    this.suppliers = response.data.data.items
                })
        },
        /* --- Client Contract ---*/
        searchClientContract(search, loading) {
            this.suppliers = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getCContract(1, { name: search }, 100);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async getCContract(page = 1, filter = null, limit = 100) {
            await this.$store.dispatch('ContractController/getListClientContractsSearchAll', [page, filter, limit])
                .then(response => {
                    this.client_contract = response.data.data.contracts
                })
        },
        selectCContract(item) {
            if (this.vendor_linking.service_category) this.vendor_linking.service_category = null;
            if (this.vendor_linking.property) this.vendor_linking.property = null;
            if (item) {
                this.loading.serviceCategory = true
                this.loading.properties = true
                this.loading.supplierContract = true
                this.vendor_linking.client_contract_id = item.id
                new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${item.id}/tree-service-categories/0`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(response => {
                            this.service_category = response.data.data
                            this.loading.serviceCategory = false
                        })
                        .catch(error => {
                            this.loading.serviceCategory = false
                        });
                });

                new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${item.id}/tree-properties/0`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(response => {
                            this.property = response.data.data;
                            this.loading.properties = false
                        })
                        .catch(error => {
                            this.loading.properties = false
                        });
                });

                this.$store.dispatch('ContractController/getRelatedSupplier', {
                        contract_id: item.id,
                        contract_type: 's_contract'
                    })
                    .then(response => {
                        this.supplier_contract = response.data.data.listSuppler
                        this.loading.supplierContract = false
                    })
                    .catch(error => {
                        this.loading.supplierContract = false
                    })
            } else {
                this.serviceCategory = [];
                this.supplier_contract = [];
                this.property = [];
            }
        },
        getVendorLinkingStatus() {
            let filter = { reference_type: "Vendor linking status" };
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.vendor_linking_status = response.items;
                })
        }
    }
}
</script>